export default __webpack_public_path__ + "static/media/basket-close-light.1d3878e9.svg";